import React, { useContext } from 'react';
import {
  GIFTING_DELIVERY_IMAGE,
  GIFTING_DISCOUNT_IMAGE,
  GIFTING_GIFTPACK_IMAGE,
  GIFTING_LOCAL_IMAGE,
} from '../../../../config/constants/images';
import { BRAND_WOWCHER } from '../../../../config/setup/setup';
import {
  GIFTING_EXPLAINED_DELIVERY,
  GIFTING_EXPLAINED_DISCOUNTS,
  GIFTING_EXPLAINED_GIFTPACK,
  GIFTING_EXPLAINED_PDF,
} from '../../../../config/text/text';
import ThemeContext from '../../../../providers/ThemeProvider';

const GiftingExplained = () => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className="gifting_container">
        <div className="gifting-flex-container">
          <div className="gifting-flex-block">
            <img
              alt="Discounts Hidden"
              className="gifting-image-big"
              src={GIFTING_DISCOUNT_IMAGE[process.env.NEXT_PUBLIC_BRAND]}
            />
            <div>
              <span
                data-number="1. "
                data-text={
                  GIFTING_EXPLAINED_DISCOUNTS[process.env.NEXT_PUBLIC_BRAND]
                }
              />
            </div>
          </div>
          <div className="gifting-flex-block ">
            <img
              alt="Personalized Gift Pack"
              className="gifting-image"
              src={GIFTING_GIFTPACK_IMAGE[process.env.NEXT_PUBLIC_BRAND]}
            />
            <div className="alignment-mobile-giftpack">
              <span
                data-number="2. "
                data-text={
                  GIFTING_EXPLAINED_GIFTPACK[process.env.NEXT_PUBLIC_BRAND]
                }
              />
            </div>
          </div>
        </div>
        <div className="gifting-flex-container">
          <div className="gifting-flex-block">
            <img
              alt="Multiple Delivery Options"
              className="gifting-image-small"
              src={GIFTING_DELIVERY_IMAGE[process.env.NEXT_PUBLIC_BRAND]}
            />
            <div>
              <span
                data-number="3. "
                data-text={
                  GIFTING_EXPLAINED_DELIVERY[
                    process.env.NEXT_PUBLIC_SITE || BRAND_WOWCHER
                  ]
                }
              />
            </div>
          </div>
          <div className="gifting-flex-block alignment-mobile">
            <img
              alt="PDF Available"
              className="gifting-image"
              src={GIFTING_LOCAL_IMAGE[process.env.NEXT_PUBLIC_BRAND]}
            />
            <div>
              <span
                data-number="4. "
                data-text={GIFTING_EXPLAINED_PDF[process.env.NEXT_PUBLIC_BRAND]}
              />
            </div>
          </div>
        </div>
      </div>

      <style jsx>
        {`
        .gifting-image {
          max-width: 111px; 
          max-height: 120px; 
          width: auto; 
          height: auto; 
          display: block;
          margin: auto; 
        }
        .alignment-mobile{
            margin-top: -8%;
        }
        .gifting-image-small{
            max-width: 128px; 
          max-height: 120px; 
          width: auto; 
          height: auto; 
          display: block;
          margin: auto;
        }
        .gifting-image-big{
            max-width: 87px; 
            max-height: 100px; 
            width: auto; 
            height: auto; 
            display: block; 
            margin: auto; 
        }
        .gifting_container {
          padding-top: 6%; 
          padding-bottom: 8%;
          width: 100%;
        }
        .gifting-flex-container {
          display: flex;
          flex-direction: row;
          justify-content: space-around; 
          align-items: center; 
          margin-bottom: 1em; 
          width: 100%;
          flex-wrap: wrap;
          margin-top: 3%;
        }
        .gifting-flex-block{
            display  flex;
            flex-direction : column;
            box-sizing: border-box; 
            padding: 0 10px; 
            width: 50%;
            align-items: center; 
            justify-content: center; 
        }
        /* Target the span that contains the number and period */
        .gifting-flex-block div span:first-child::before {
        content: attr(data-number); 
        color: ${theme.colors.headerprimary}; 
        margin-right: 0.5em; 
        font-size: 1rem;
        }
        .gifting-flex-block > div {
            width: 100%; 
            text-align: center; 
            display: block; 
          }
        .gifting-flex-block div span:first-child::after {
        content: attr(data-text); 
        visibility: visible; 
        font-size: 1rem;
        text-align: center;
        }
       .gifting-flex-block div {
        margin-top: 4%
       }
       .alignment-mobile-giftpack{
        margin-top: 9% !important;
       }
       @media only screen and (min-width: ${theme.breakpoints.lgUp}) {
        .gifting-flex-block div span:first-child::before {
            font-size: 1.2em;
            }
           
            .gifting-flex-block div span:first-child::after {
            font-size: 1.1em;
            }
            .alignment-mobile{
                margin-top: -3%;
            }
            .gifting-image {
                max-width: 140px; 
                max-height: 120px; 
              }
              .gifting-image-small{
                  max-width: 160px; 
                max-height: 120px; 
              }
              .gifting-image-big{
                  max-width: 100px; 
                  max-height: 100px; 
              }
              .alignment-mobile-giftpack{
                margin-top: 5% !important;
               }
      }
    `}
      </style>
    </>
  );
};

export default GiftingExplained;
